import type { Plugin } from 'chart.js';

import { palette } from '#src/palette.ts';

export const customPlugins: Array<Plugin<'line'>> = [
  {
    id: 'draw-vertical-line',
    beforeDraw: (chart) => {
      // @ts-expect-error
      if (chart.tooltip?._active?.length) {
        // @ts-expect-error
        const x = chart.tooltip._active[0].element.x;
        const yAxis = chart.scales.y;
        const ctx = chart.ctx;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, yAxis.top);
        ctx.lineTo(x, yAxis.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = palette.grey[400];
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];
